const INTV_MENU_CATS = [
    {
        "id": "intv-cat-manual-c-spine-stabilization",
        "label": "Manual c-spine stabilization",
        "items": [
            "menu-item-spinal-immobilization-technique-manual-c-spine"
        ]
    },
    {
        "id": "intv-cat-airway",
        "label": "Airway",
        "items": [
            "heading-bls",
            "heading-open-airway",
            "menu-item-open-airway-method-head-tilt",
            "menu-item-open-airway-method-modified-jaw-thrust",
            "heading-establish-patency",
            "menu-item-airway-patency-technique-suction-airway",
            "heading-remove-foreign-body-obstructions",
            "menu-item-manual-finger-sweep",
            "menu-item-magill-forceps-assisted",
            "menu-item-slat",
            "menu-item-heimlich-maneuver",
            "menu-item-back-blows-and-chest-thrusts",
            "heading-insert-adjunct",
            "menu-item-oropharyngeal-airway",
            "menu-item-nasopharyngeal-airway",
            "heading-als",
            "heading-intubation",
            "menu-item-advanced-airway-adjunct",
            "menu-item-orotracheal-intubation",
            "menu-item-nasotracheal-intubation",
            "heading-medication-facilitated-intubation",
            "menu-item-rapid-sequence-intubation",
            "menu-item-sedation-assisted-intubation",
            "heading-crico",
            "menu-item-needle-cricothyrotomy",
            "menu-item-surgical-cricothyrotomy",
        ]
    },
    {
        "id": "intv-cat-manage-oxygenation-and-ventilation",
        "label": "Manage oxygenation and ventilation",
        "items": [
            "menu-item-supplemental-oxygen-device-nasal-cannula",
            "menu-item-supplemental-oxygen-device-non-rebreather-mask",
            "menu-item-ventilation-technique-bag-valve-mask",
        ]
    },
    {
        "id": "intv-cat-circulation-management",
        "label": "Circulation management",
        "items": [
            "heading-severe-external-bleeding",
            "menu-item-control-severe-bleeding-technique-direct-pressure",
            "menu-item-control-severe-bleeding-technique-tourniquet",
            "menu-item-control-severe-bleeding-technique-2nd-tourniquet",
            "menu-item-control-severe-bleeding-technique-pack-wound-with-gauze",
            "menu-item-control-severe-bleeding-technique-pressure-bandage",
            "menu-item-control-severe-bleeding-technique-load-and-go",
            "heading-manage-internal-bleeding",
            "menu-item-splint-fractures",
            "heading-manage-shock",
            "menu-item-control-shock-technique-keep-patient-warm",
            "menu-item-control-shock-technique-administer-high-concentration-o2",
            "menu-item-control-shock-technique-place-patient-supine-position",
            "menu-item-control-shock-technique-administer-iv-boluses",
        ]
    },
    {
        "id": "intv-cat-manage-thoracic-trauma",
        "label": "Manage thoracic trauma",
        "items": [
                "menu-item-occlusive-dressing",
                "menu-item-pleural-decompression",
        ]
    },
    {
        "id": "intv-cat-spinal-motion-restriction",
        "label": "Spinal motion restriction",
        "items": [
            "menu-item-spinal-immobilization-technique-manual-c-spine2",
            "menu-item-spinal-immobilization-technique-cervical-collar",
            "menu-item-spinal-immobilization-technique-transfer-to-device",
            "menu-item-spinal-immobilization-technique-attach-cid",
        ]
    },
    {
        "id": "intv-cat-extrication-and-transport",
        "label": "Extrication and transport",
        "items": [
            "heading-transfer",
            "menu-item-transfers-patient-method-walk-patient",
            "menu-item-transfers-patient-method-place-directly-on-stretcher",
            "menu-item-place-immobilized-patient-on-stretcher",
            "heading-transport",
            "menu-item-transport",
        ]
    },
    {
        "id": "intv-cat-manage-wounds-and-specific-injuries",
        "label": "Manage wounds and specific injuries",
        "items": [
            "menu-item-apply-sterile-dressings",
            "menu-item-splint-fractures2",
            "heading-amputation",
            "menu-item-sterile-dressing-soft-tissue",
            "menu-item-retrieve-amputated-body-part",
            "menu-item-wrap-body-part-in-saline-soaked-gauze",
            "menu-item-place-body-part-in-bag",
            "menu-item-keep-body-part-cool",
            "menu-item-transport-body-part-to-receiving-facility",
        ]
    },
    {
        "id": "intv-cat-manage-pain-nausea-vomiting",
        "label": "Manage pain, nausea, vomiting",
        "items": [
            "menu-item-prepare-and-administer-pain-nausea-vomiting-medications",
        ]
    },
    {
        "id": "intv-cat-sedate-agitated-or-combatitive-patient",
        "label": "Sedate agitated or combatitive patient",
        "items": [
            "menu-item-prepare-and-administer-sedative",
        ]
    }
]

export default INTV_MENU_CATS